<template>
  <div id="admin-issue">
    <b-modal id="closeIssueModal" centered>
      <template #modal-header><h4>Zamykanie zgłoszenia</h4></template>
      <p>CZy na pewno chcesz zamnąć to zgłoszenie?</p>
      <template #modal-footer>
        <vs-button type="border round" icon-pack="feather" icon="icon-x"
                   @click="$bvModal.hide('closeIssueModal')">
          Anuluj
        </vs-button>
        <vs-button color="danger" type="filled round" @click="closeIssue(issue.uuid)" class="mr-4">
          Zamknij zgłoszenie
        </vs-button>
      </template>
    </b-modal>
    <vx-card>
      <b-container fluid>
        <b-row>
          <b-col>
            <h4>Zgłoszenia</h4>
          </b-col>
        </b-row>
        <b-row v-if="issues && issues.length>0">
          <b-col cols="3" class="mt-3">
            <ul>
              <li
                v-for="i in issues" :key="i.uuid"
                @click="getIssue(i.uuid)"
                class="issue-item"
                :class="[issue && i.uuid === issue.uuid ? 'bg-wod-blue' : '' , i.is_open ? '' : 'closed-issue']"
              >
                <p><strong>{{ i.topic }}</strong></p>
                <p><small>{{(new Date(i.updated_at)).toLocaleString()}}</small></p>
              </li>
            </ul>
          </b-col>
          <b-col v-if="issue" class="issue-chat mt-3" :class="issue.is_open ? '' : 'closed'">
            <b-row>
              <b-col>
                <h4 v-if="issue.topic">{{issue.topic}}</h4>
              </b-col>
              <b-col>
                <vs-button v-if="issue.is_open" type="border round" @click="$bvModal.show('closeIssueModal')" class="float-right m-0">Zamknij zgłoszenie</vs-button>
                <p v-else class="text-color-base float-right">Zgłoszenie zostało zamknięte</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p class="text-color-base text-center">
                  Utworzono:
                  <br>
                  <strong>{{(new Date(issue.created_at)).toLocaleString()}}</strong>
                </p>
              </b-col>
            </b-row>
                <b-row v-if="issue.messages" class="my-6">
                  <b-col cols="12"
                         v-for="(m, index) in issue.messages"
                         :key="m.uuid"
                  >
                    <div v-if="m.body" class="issue-message" :class="m.author_id === issue.creator_id ? 'issue-creator' : ''">
                      <p class="message-body"
                         :class="[!issue.messages[index-1] || m.author.uuid !== issue.messages[index-1].author.uuid ? 'first' : '',
                         !issue.messages[index+1] || m.author.uuid !== issue.messages[index+1].author.uuid ? 'last' : '']"
                      >
                        {{ m.body }}
                      </p>
                      <p class="mt-3" v-if="!issue.messages[index+1] || m.author.uuid !== issue.messages[index+1].author.uuid">
                        <strong>{{m.author.first_name}} {{m.author.last_name}}</strong>
                        <br>
                        <span class="small">{{ (new Date(m.created_at)).toLocaleString() }}</span>
                      </p>
                    </div>
                  </b-col>
                </b-row>
            <b-row v-if="issue.is_open" class="new-message">
              <b-col class="d-flex">
                <vs-input v-model="payload.body" type="text" placeholder="Napisz wiadomość..." class="w-100" />
                <vs-button class="ml-2" type="border round" @click="respondIssue(issue.uuid)">Wyślij</vs-button>
              </b-col>
            </b-row>
              </b-col>
            </b-row>
      </b-container>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios"
import notification from "@/notification"

export default {
  name: "Issues.vue",
  data(){
    return{
      issue: null,
      issues: null,
      formErrors: {},
      payload: {
        body: null
      },
    }
  },

  mounted () {
    this.getIssues()
  },

  methods: {
    getIssues() {
      axios.get('/ez/issues')
        .then(response => {
          this.issues = response.data.data
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
    },

    getIssue(uuid) {
      axios.get(`/ez/issues/${uuid}`)
        .then(response => {
          this.issue = response.data.data
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
    },

    respondIssue(uuid) {
      axios.post(`/ez/issues/${uuid}/respond`, this.payload)
        .then(() => {
          this.getIssue(uuid)
          this.payload = {body: null}
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
    },

    closeIssue(uuid) {
      axios.patch(`/ez/issues/${uuid}/close`)
        .then(() => {
          this.$bvModal.hide('closeIssueModal')
          this.getIssues()
          this.getIssue(uuid)
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
    },

  },
}
</script>

<style lang="scss">
#admin-issue {

  .issue-item {
    padding: 14px;
    margin-bottom: 4px;
    border-radius: 7px;
    cursor: pointer;
    background-color: #f7f7f7;
    &.closed-issue {
      color: #b6b6b6;
    }
  }

  .issue-chat {
    position: relative;
    padding-top: 24px;
    padding-bottom: 64px;
    &.closed {
      color: #b6b6b6;
    }
    .issue-message {
      .message-body {
        padding: 12px 12px;
        background-color: #f3f3f3;
        max-width: 100%;
        margin: -8px 0;
        border-radius: 10px;
        display: inline-flex;
        &.first {
          padding-top: 8px;
          margin-top: 0;
        }
        &.last {
          padding-bottom: 8px;
          margin-bottom: 0;
        }
      }
      &:not(.issue-creator) {
        float: right;
        text-align: right;
        .message-body {
          background-color: #00C9A4;
          color: $white;
        }
      }
    }
    .new-message {
      position: absolute;
      bottom: 15px;
      left: 15px;
      width: 100%;
    }
  }
}

</style>
